import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { SparkFavouriteAttribute } from 'types/Spark/SparkFavourite';

type mutationVariables = Partial<SparkFavouriteAttribute>;

export function useCreateSparkFavourite() {
  const queryClient = useQueryClient();

  const createSparkFavorites = (sparkFavourite: mutationVariables) => {
    if (!sparkFavourite) {
      Promise.reject('Spark Favourite can not be null');
    }

    const body = {
      data: {
        type: 'sparkFavourites',
        attributes: sparkFavourite,
      },
    };

    return fetchWrapper<SparkFavouriteAttribute>({
      url: `SparkFavourites`,
      method: 'Post',
      body: body,
    });
  };

  return useMutation('createSparkFavorites', createSparkFavorites, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['sparks']);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to create spark favourite: ${error.message}`);
      }
    },
  });
}
